import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import "react-quill/dist/quill.snow.css";
import {
  Send,
  Mail,
  Sparkles,
  Calendar,
  BarChart,
  Loader2,
  ChevronDown,
  MessageSquare,
  CheckCircle,
  Clock,
} from "lucide-react";
import './PromotionEmail.css'

function PromotionMail({ match }) {
  const [value, setValue] = useState("");
  const [subject, setSubject] = useState("");
  const [sendVia, setSendVia] = useState("");
  const [loader, setLoader] = useState(false);

  // Stats data
  const [stats, setStats] = useState({
    totalEmails: 1, // Default values
    delivered: 0,
    opened: 0,
    clicked: 0,
  });

  useEffect(() => {
    // You can fetch actual stats here
    setStats({
      totalEmails: 1567,
      delivered: 1450,
      opened: 1200,
      clicked: 890,
    });
  }, []);

  const handleSubmit = async () => {
    try {
      if (value && subject && sendVia) {
        setLoader(true);
        let payload = {
          template: value,
          subject: subject,
          sendVia: sendVia,
        };
        const userData = await api.sendMailToAllUser(payload);
        if (userData.success) {
          alert(userData.message);
          setLoader(false);
        } else {
          alert("Something went wrong, email not sent ");
          setLoader(false);
        }
      } else {
        setLoader(false);
        alert("Please insert fields");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong, email not sent ");
    }
  };

  const handleSubmitEid = async () => {
    try {
      setLoader(true);
      let payload = {
        template: value,
        subject: subject,
      };
      const userData = await api.sendMailToAllUserEid(payload);
      if (userData.success) {
        alert(userData.message);
        setLoader(false);
      } else {
        alert("Something went wrong");
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong, email not sent ");
    }
  };

  const handleSubmitMontlySummary = async () => {
    try {
      setLoader(true);
      const userData = await api.sendMonthlySummaryMail();
      if (userData.success) {
        alert(userData.message);
        setLoader(false);
      } else {
        alert("Something went wrong ");
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong ");
    }
  };

  var Editor = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  return (
    <>

      <div className="dashboard-email">
        {/* Header with integrated stats */}
        <div className="dashboard-header-container">
          <div className="header-main">
            <div className="header-icon">
              <Mail size={24} />
            </div>
            <div className="contents-header">
              <div className="header-title-row">
                <h1>Email Campaign Manager</h1>
              </div>
              <p>Send beautiful emails to all your users</p>
            </div>
          </div>

          {/* Stats Grid integrated in header */}
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon stat-icon-1">
                <MessageSquare size={24} />
              </div>
              <div className="stats-info">
                <h3>{stats.totalEmails.toLocaleString()}</h3>
                <p>TOTAL EMAILS SENT</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon stat-icon-2">
                <CheckCircle size={24} />
              </div>
              <div className="stats-info">
                <h3>{stats.delivered.toLocaleString()}</h3>
                <p>DELIVERED</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon stat-icon-3">
                <Clock size={24} />
              </div>
              <div className="stats-info">
                <h3>{stats.opened.toLocaleString()}</h3>
                <p>OPENED</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon stat-icon-4">
                <BarChart size={24} />
              </div>
              <div className="stats-info">
                <h3>{stats.clicked.toLocaleString()}</h3>
                <p>CLICKED</p>
              </div>
            </div>
          </div>
        </div>

        {/* Email Form Card */}
        <div className="email-card">
          <div className="cards-header">
            <div className="card-icon">
              <Send size={20} />
            </div>
            <h2>Compose New Email</h2>
          </div>

          <div className="form-group">
            <label>
              <Mail size={16} />
              Email Subject
            </label>
            <input
              type="text"
              className="form-control"
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Enter email subject..."
            />
          </div>

          <div className="form-group">
            <label>
              <Send size={16} />
              Send Via
            </label>
            <div className="select-wrapper">
              <select
                name="category"
                onChange={(e) => setSendVia(e.target.value)}
                className="form-control"
              >
                <option value="">Select sender email</option>
                <option value="noreply">noreply@waqarzaka.net</option>
                <option value="info">info@waqarzaka.net</option>
              </select>
              <div className="select-arrow">
                <ChevronDown size={20} />
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>
              <Sparkles size={16} />
              Email Content
            </label>
            <div className="editor-container">
              <ReactQuill
                placeholder="Compose your email here..."
                modules={Editor}
                theme="snow"
                value={value}
                onChange={setValue}
              />
            </div>
          </div>

          <div className="button-group">
            <button onClick={handleSubmit} className="btn btn-primary">
              <Send size={18} />
              Send Email Campaign
            </button>

            <button
              onClick={handleSubmitMontlySummary}
              className="btn secondary-btn"
            >
              <Calendar size={18} />
              Send November Summary
            </button>
          </div>
        </div>

        {loader && (
          <div className="loader-overlay">
            <div className="loader-content">
              <Loader2 size={48} className="loader-spinner" />
              <p className="loader-text">Sending emails...</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default PromotionMail;
